import type { OrderItemDTO } from './OrderItemDTO';

export interface StoreOrderDTO {
  id: string;
  masterOrderId: string;
  storeId: string;
  userId: string;
  status: string;
  createdAt: string; // ISO date string from backend
  items: OrderItemDTO[];
  subtotal: number;
  trackingNumber?: string | null;
  trackingLink?: string | null;
  expectedShippingDate?: string | null;
}

export enum StoreOrderItemStatus {
  ACCEPTED = 'ACCEPTED',
  REJECTED_REFUND_IN_PROGRESS = 'REJECTED_REFUND_IN_PROGRESS',
  SHIPPED = 'SHIPPED',
}
